export const AUTH_COOKIE_NAME = 'mn-token';
export const OT_DATA_SUBJECT_PARAMS_COOKIE_NAME = 'mn-ot-data-subject-params';

// This is used to track any consent settings changes external to app.milanote.com (such as from milanote.com)
export const OT_LAST_ACTIVE_GROUPS_LOCAL_STORAGE = 'milanote.oneTrustActiveGroups';
